import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { MEDIA } from '../../../../../constants'

export const ImpactDestinationsWrapper = styled(Box)(`
    font-style: normal;
    font-weight: 400; // 300;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: #000000;
    border:1px solid #000;
    position: relative;
    height:450px;
    margin-left: 25px;
    margin-bottom: 30px;
    position: relative;

    &.noDataInFilters_true svg {
      opacity: 0;
    }

    & ul {
        list-style-position: outside;
        margin-left: 35px;
    }
    .legendItem {
        margin-left: 0;
        margin-right: 10px;
    }

    .infoRow{margin-top:50px !important;}

  .rowLine {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -20px;
    & span {
      width:auto;
      background: #fff;
      display: inline-block;
      position: absolute;
      left: 50%;
      top: -11px;
      font-size: 12px;
      font-weight: 400;
      padding: 0 10px;
      transform: translate(-50%);
      text-align: center;
      line-height: 18px;
      text-wrap: nowrap;
    }
  }
  
  .rowLine:before {
    content: "";
    width: 100%;
    height: 1px;
    background: #7E7E7E;
    position: absolute;
    margin-top: -1px;
    left: 0;
  }
  
  .rowLine:after {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-color: transparent transparent transparent #7E7E7E;
    position: absolute;
    margin-top: -5px;
    right: 0;
  }

  .columnLine {
    position: absolute;
    width: 1px;
    height: 100%;
    background: #7E7E7E;
    top: 0;
    left: -20px;
    /*
    & span {
      width: auto;
      background: #fff;
      display: inline-block;
      position: absolute;
      left: -34px;
      top: 48%;
      font-size: 12px;
      font-weight: 400;
      padding: 0 10px;
      transform: rotate(-90deg);
      text-align:center;
      text-wrap: nowrap;
    }
    */
    & span.new {
      position: absolute;
      top: 50%;
      left: 0;

      transform: translateX(-50%) translateY(-50%) rotate(-90deg);

      background: #fff;
      display: inline-block;

      font-size: 12px;
      font-weight: 400;
      padding: 0 10px;

      white-space: nowrap;
      text-align: center;
    }
  }

  .columnLine:after {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0px 5px 5px 5px;
    border-color: transparent transparent #7E7E7E transparent ;
    position: absolute;
    margin-top: 0;
    left: -5px;
  }
 
  @media (max-width: ${MEDIA.lg}) {
    padding:20px 20px 40px 20px;
  }

    & .tooltip .overlay{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index:1;
  }

  & .tooltip .popup{
    position: absolute;
    width: 280px;
    min-height: 160px;
    left: calc(50% - 140px);
    top: calc(50% - 80px);

    margin-left: -74px;
    margin-top: -49px;

    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    z-index:2;
    display:flex;
    flex-direction:column;
    padding:10px 25px 20px 15px;
  }

  & .tooltip .popup .driverName{
    font-weight: 600; // 500;
  }

  & .tooltip .popup .close{
    position:absolute;
    right:10px;
    top:3px;
  }

  & .tooltip .popup * {
    font-size: 12px;
    line-height: 18px;
    color: #000;
  }

  & .tooltip .popup .description{
    padding:10px 0;
    font-weight:normal;
  }
`)
